export default __webpack_public_path__ + "static/media/OCS22Stats.7366fc1a.pdf";